export default __webpack_public_path__ + "static/11-d2b4ce195271e4d7a0d6f23952e8c73e.jpg";